module.exports = __webpack_public_path__ + "static/media/RealTimeNotification.fb8d9a95.svg";